<section class="section">
   <div class="container">
      <form [formGroup]="searchForm">
         <!-- <form [formGroup]="searchForm" (ngSubmit)="onSubmit()"> -->


            <div class="field">

             </div>

         <div class="field is-grouped">

            <div class="control">
                <input formControlName="code"
                    class="input is-focused is-small" 
                    type="text" 
                    placeholder="Kod / Barkod" 
                    autofocus
                >
            </div>

            <ng-container *ngIf="!searchForm.get('code').value">

                <div class="control">
                    <div class="select is-primary is-small">
                        <select formControlName="brand">
                            <option [ngValue]="''" selected>Marka</option>
                            <option *ngFor="let brn of brandsList" [ngValue]="brn">{{ brn }}</option>
                        </select>
                    </div>
                </div>
                
                <ng-container *ngIf="seriesList$">
                    <ng-container *ngIf="seriesList$.length > 0">
                        <div class="control">
                            <div class="select is-primary is-small">
                                <select formControlName="series" placeholder="Seri">
                                    <option selected value="">Seri</option>
                                    
                                    <option *ngFor="let seri of seriesList$" [value]="seri">{{ seri }}</option>
                                </select>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                
                <div class="control">
                    <div class="select is-danger is-small">
                        <select formControlName="category">
                            <option selected value="">Kategori</option>
                            <option *ngFor="let cat of categoriesList" [value]="cat">{{ cat }}</option>
                        </select>
                    </div>
                </div>
                
                <ng-container *ngIf="subcategoriesList$">
                    <ng-container *ngIf="subcategoriesList$.length > 0">
                        <div class="control">
                            <div class="select is-danger is-small">
                                <select formControlName="subcategory">
                                    <option selected value="">Alt kategori</option>
                                    
                                    <option *ngFor="let subcat of subcategoriesList$" [ngValue]="subcat">{{ subcat }}</option>
                                </select>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
            <button class="button is-info is-small" type="submit" (click)="onSubmit()">
               <span class="icon">
                  <i class="fas fa-cloud-download-alt"></i>
               </span>

               <span class="has-text-weight-semibold"> Getir</span>
            </button>
            <button class="button is-info is-small is-outlined" (click)="resetForm()">
               <span class="icon">
                  <i class="fas fa-eraser"></i>
               </span>

               <span class="has-text-weight-semibold"> Reset</span>
            </button>
         </div>
      </form>

      <section class="section">
         <div class="container">
            <div class="columns">
               <div class="column">
                  <table class="table is-striped is-narrow is-hoverable" *ngIf="(searchResult$ || searchItems$) | async">
                     <thead>
                        <tr>
                           <th>Kod</th>
                           <th>İsim</th>
                           <th>Marka</th>
                           <th>Seri</th>
                           <th>Kategori</th>
                           <th>Alt Kategori</th>
                           <th>Fiyat</th>
                           <th>Stok</th>
                           <th>Görsel</th>
                        </tr>
                     </thead>

                     <tbody>

                        <ng-container *ngIf="searchItems$ |async">
                            <tr *ngFor="let sitem of searchItems$ | async">
                                <td>{{ sitem.code }}</td>
                                <td>{{ sitem.name | slice: 0:20 }}</td>
                                <td>{{ sitem.brand | slice: 0:10 }}</td>
                                <td>{{ sitem.series | slice: 0:10 }}</td>
                                <td>{{ sitem.cat | slice: 0:10 }}</td>
                                <td>{{ sitem.subcat | slice: 0:10 }}</td>
                                <td>{{ sitem.sprice | currency: sitem.scurr:'symbol-narrow' }}</td>
                                <td>{{ sitem.stock }}</td>
                                <td>
                                   <figure class="image is-64x64">
                                      <img [src]="sitem.imgUrl" />
                                   </figure>
                                </td>
                             </tr>
                        </ng-container>
                        <tr *ngFor="let item of searchResult$ | async">
                           <td>{{ item.code }}</td>
                           <td>{{ item.name | slice: 0:20 }}</td>
                           <td>{{ item.brand | slice: 0:10 }}</td>
                           <td>{{ item.series | slice: 0:10 }}</td>
                           <td>{{ item.cat | slice: 0:10 }}</td>
                           <td>{{ item.subcat | slice: 0:10 }}</td>
                           <td>{{ item.sprice | currency: item.scurr:'symbol-narrow' }}</td>
                           <td>{{ item.stock }}</td>
                           <td>
                              <figure class="image is-64x64">
                                 <img [src]="item.imgUrl" />
                              </figure>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </section>

      <!-- <div>
            <h1 class="title">CATEGORY</h1>
            {{categories['Boyama']}}
        </div> -->

      <p>Form value: {{ searchForm.value | json }}</p>

      <!-- <p>{{ brands | json }}</p> -->
   </div>
</section>
